import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import is from 'is_js';
import Content from '../content/loadable';
import HTML from '../html/loadable';
import BrowserSupport from '../browser_support/loadable';
import DnDRoutes from './DnDLoadable';

export default class App extends React.Component {
  componentDidMount() {
    // Disable mouse right-click
    // document.oncontextmenu = (event) => {
    //   if (event.button === 2) {
    //     event.preventDefault();
    //     return false;
    //   }
    //   return true;
    // };
  }
  render() {
    // Detect Edge browser
    // const isEdge = is.edge();

    let app;

    // Check browsers
    // Only support:
    //  + Chrome
    //  + Firefox
    //  + Safari
    //  + IE11
    //  + Edge
    if (
      (is.chrome() || is.firefox() || is.safari() || is.ie() || is.edge())
      && !is.opera()
    ) {
      app = (
        <Container fluid className="root-wrapper">
          <Switch>
            <Route path="/content" component={Content} />
            <Route exact path="/html" component={HTML} />
            <Route exact path="/html/edit" component={HTML} />
            <DnDRoutes />
          </Switch>
        </Container>
      );
    } else {
      app = (
        <BrowserSupport />
      );
    }

    // Render app
    return app;
  }
}



// WEBPACK FOOTER //
// ./src/containers/app/App.js